import { Injectable } from '@angular/core';
import * as GeneralActions from './general.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { distinct, of, skip, switchMap, tap } from 'rxjs';
import { ColumnsService } from '../services/columns.service';
import { catchError, map } from 'rxjs/operators';
import * as AuthActions from '../auth/store/actions/auth.actions';

@Injectable()
export class GeneralEffects {
  public setLang$ = createEffect(() =>
    this._actions.pipe(
      ofType(GeneralActions.setLang),
      distinct(),
      skip(1),
      tap(() => {
        location.reload();
      }),
      switchMap(() =>
        of(GeneralActions.setLangSuccess()),
      ),
    ),
  );

  public getColumnsGroup$ = createEffect(() =>
    this._actions.pipe(
      ofType(GeneralActions.getColumnGroups),
      switchMap(() =>
        this._service.getColumns()
          .pipe(
            map(columnGroups => GeneralActions.getColumnGroupsSuccess({ columnGroups })),
            catchError(() => of(GeneralActions.getColumnGroupsFailure())),
          ),
      ),
    ),
  );

  public clearStore$ = createEffect(() =>
    this._actions.pipe(
      ofType(AuthActions.logout),
      switchMap(() => of(GeneralActions.clearStore())),
    ),
  );

  constructor(
    private _actions: Actions,
    private _service: ColumnsService,
  ) {
  }
}
